import { Component, Input, OnInit, Output, EventEmitter, OnDestroy, ViewChild, AfterViewInit } from '@angular/core';
import { map, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { PetitionBuilderService } from 'src/app/services/petition-builder.service';
import { select, Store } from '@ngrx/store';
import { getStepDetails } from '../../store/selectors/sub-task-details.selectors';
import { TaskStep } from 'src/app/data/models/task-step.model';
//import { FroalaEditorOptions } from '../../../../data/constants/froala-editor-options';
import { ToastrService } from 'ngx-toastr';
import { NgForm } from '@angular/forms';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { GCI140Service } from '../../../../services/gci140.service';
import { ImagilityBaseResponse } from '../../../../data/models/response.model';
import { environment } from 'src/environments/environment';
import { MarkCleanFormAction, MarkDirtyFormAction } from 'src/app/app-state/actions/dirty-form.actions';
import { getSuperTask } from 'src/app/modules/superTask/task-state/reducers/task.reducer';
import { UploadImageDialogComponent } from "../../../custom-kendo/upload-image-dialog/upload-image-dialog.component";
import { EditorComponent } from "@progress/kendo-angular-editor";
import { AppServicesLibraryService } from 'app-services-library';


@Component({
  selector: 'i140-letter-preview',
  templateUrl: './letter-preview.component.html',
  styleUrls: ['./letter-preview.component.scss']
})
export class LetterPreviewComponent implements OnInit, OnDestroy, AfterViewInit {

  @ViewChild('previewForm', { static: false }) previewForm: NgForm;
  @ViewChild("previewimageupload") public previewimageupload: UploadImageDialogComponent;
  @Output() @ViewChild("previewkendoeditor") public previewkendoeditor: EditorComponent
  @Input()
  data: any;
  observableSubscription$ = new Subject();
  editPreview: boolean;
  stepDetails: TaskStep;
  letterType: string;
  disabledControls: boolean;

  isLastestLetterAvailable: string;
  previewLetter: string;
  latestLetterGeneratedOn: string;
  pdfSrc: string;

  @Output()
  redirectionComponent: EventEmitter<string> = new EventEmitter<string>();
  // public options = FroalaEditorOptions.EditorOptions;

  constructor(
    private pbService: PetitionBuilderService,
    private gcI140Service: GCI140Service,
    protected store: Store<any>,
    private toastService: ToastrService,
    private dynamicDialogConfig: DynamicDialogConfig,
    private appServicesLibraryService: AppServicesLibraryService
  ) {
    this.letterType = sessionStorage.getItem('typeOfLetter');
    this.disabledControls = false;
    this.pdfSrc = null;
    this.editPreview = false;
  }

  ngOnInit(): void {
    // Get Specific step details by passing step code
    this.store.pipe(select(getStepDetails, { id: this.dynamicDialogConfig.data.stepId })).pipe(takeUntil(this.observableSubscription$)).subscribe((data: TaskStep) => {
      this.stepDetails = data;
      this.toggleControlsStatus();
      this.loadPreview();
      this.getLastestGeneratedPDF();
    });

  }

  public letterpreviewimageuploaddialog() {
    this.previewimageupload.open();
  }


  ngAfterViewInit() {
    this.previewForm.form.valueChanges.pipe(
      map(() => this.previewForm.dirty),
    ).pipe(takeUntil(this.observableSubscription$)).subscribe(dirty => {
      if (dirty) {
        this.store.dispatch(new MarkDirtyFormAction({
          dirty: true
        }));
      } else {
        this.store.dispatch(new MarkCleanFormAction({
          dirty: false
        }));
      }
    });
  }

  //Toggle controls status based on step status
  toggleControlsStatus() {
    this.disabledControls = this.appServicesLibraryService.formToBeDisabled(this.stepDetails.stepStatusDetails.stepStatusCode);
    // this.disabledControls = this.stepDetails.stepStatusDetails.stepStatusCode === "NEW" || this.stepDetails.stepStatusDetails.stepStatusCode === "COMPLETE" || this.stepDetails.stepStatusDetails.stepStatusCode === "SUBMIT" ? true : false;
  }

  getLastestGeneratedPDF() {
    this.gcI140Service.getI140Documents(this.dynamicDialogConfig.data.superTaskId, this.dynamicDialogConfig.data.subTaskId,
      this.dynamicDialogConfig.data.i140CaseId, 'DOCTYP').subscribe((response: ImagilityBaseResponse) => {
        if (response.data.find(x => x.fileCategory.code === this.letterType)) {
          this.isLastestLetterAvailable = response.data.find(x => x.fileCategory.code === this.letterType).fileLocation;
          this.latestLetterGeneratedOn = response.data.find(x => x.fileCategory.code === this.letterType).generatedOn;
        }
      });
  }

  viewDocument() {
    let dataSlice = this.isLastestLetterAvailable.split('/var/imagility/uploads/');
    this.pdfSrc = environment.docs + dataSlice[1];
    window.open(this.pdfSrc, '_blank');
  }

  loadPreview() {
    this.gcI140Service.getPreview(this.dynamicDialogConfig.data.superTaskId, this.dynamicDialogConfig.data.i140CaseId, this.letterType, { templateId: sessionStorage.getItem('documentTemplateId') }).pipe(takeUntil(this.observableSubscription$)).subscribe((response: ImagilityBaseResponse) => {
      this.previewLetter = response.data;
    })
  }

  editPreviewPDF() {
    if (parseInt(sessionStorage.getItem('documentTemplateId')) === 0) {
      this.redirectionComponent.emit('CreateTemplate');
    }
    else {
      this.editPreview = true;
    }
  }

  generatePDFFile() {
    this.redirectionComponent.emit('LetterPDF');
  }

  savePreviewPDF() {
    let payload = {
      templateContents: this.previewLetter,
      templateId: sessionStorage.getItem('documentTemplateId')
    };
    this.gcI140Service.updatePreview(this.dynamicDialogConfig.data.superTaskId, this.dynamicDialogConfig.data.i140CaseId, this.letterType, payload).subscribe((response: ImagilityBaseResponse) => {
      if (response) {
        this.toastService.success(response.message, 'Success');
        this.previewForm.resetForm(response.data);
        this.editPreview = false;
      }
    });
  }

  backLink() {
    if (parseInt(sessionStorage.getItem('documentTemplateId')) === 0) {
      this.redirectionComponent.emit('CreateTemplate');
    }
    else {
      this.redirectionComponent.emit('LetterTemplate');
    };
  }

  nextLink() {
    this.redirectionComponent.emit("LetterPDF");
  }

  ngOnDestroy() {
    this.observableSubscription$.next();
    this.observableSubscription$.complete();
  }

  public previewLettereditorValueChange(value: string): void {
    this.previewLetter = value;
  }
}
